<div class="container">
  <img src="assets/sad-yooga.svg" alt="">
  <div class="text">
    <h3>Ops, esse qr code não está mais válido!</h3>
    <p>Por favor, escaneie novamente o qr code da mesa.</p>
  </div>
</div>